<script lang="ts">
  let { rendering = {} } = $props();
</script>

<div class="d-inline-block mr-3 p-3 errorComponent">
  Missing <strong>componentName</strong> for {rendering?.componentName}
  <code>
    <pre>
      {JSON.stringify(rendering, null, 2)}
    </pre>
  </code>
</div>

<style>
  .errorComponent {
    border: 1px solid var(--warning);
  }
</style>
